/** Temporary region-state debug — remove after root-cause confirmed. */
export function isRegionDebugEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    if (window.localStorage.getItem('mingo_region_debug') === '1') return true;
    const params = new URLSearchParams(window.location.search);
    return params.get('debug') === '1' || params.get('region_debug') === '1';
  } catch {
    return false;
  }
}
